import React from 'react'

export const Confetti = ({className}: {className?: string}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 328 104"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero" transform="translate(4)">
        <ellipse
          cx="107.043"
          cy="4.949"
          fill="#FF9B08"
          opacity=".642"
          rx="2.133"
          ry="2.131"
          transform="rotate(-123 107.043 4.949)"
        />
        <path
          fill="#00C4C4"
          d="M3.618 65.81.005 63.55l2.258-3.62 3.613 2.262z"
          opacity=".75"
        />
        <path
          fill="#FF643D"
          d="m197.038 5.471-1.457-4.011L199.585 0l1.457 4.011z"
          opacity=".83"
        />
        <path
          fill="#4398FA"
          d="M31.155 11.252v4.528l-4.518-4.528z"
          opacity=".73"
        />
        <path
          fill="#4398FA"
          d="M296.177 13.848h-4.519l4.52-4.528z"
          opacity=".95"
        />
        <ellipse
          cx="295.236"
          cy="101.498"
          fill="#FFC800"
          opacity=".393"
          rx="2.134"
          ry="2.13"
          transform="rotate(-79 295.236 101.498)"
        />
        <path
          fill="#00C4C4"
          d="m315.806 49.947 4.196.741-.74 4.204-4.196-.741z"
          opacity=".3"
        />
        <ellipse
          cx="26.288"
          cy="99.347"
          fill="#FFC800"
          opacity=".3"
          rx="2.133"
          ry="2.131"
          transform="rotate(-123 26.288 99.347)"
        />
      </g>
      <path d="M0 0h328v104H0z" />
    </g>
  </svg>
)
